import React, { useState, useContext } from "react";
import {
  IonContent,
  IonPage,
  IonFab,
  IonFabButton,
  IonFabList, IonItem, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton, IonItemOptions,
} from "@ionic/react";
import {
  SelectField, Menu,
  IconButton,
  toaster,
  SideSheet,
  Pane,
  Heading,
  Paragraph,
  Textarea,
  Table,
  TextInputField,
  TextareaField,
  Button,
  Icon,
  TrashIcon,
  AddIcon,
  EyeOpenIcon,
  RefreshIcon,
  ResetIcon,
  ChatIcon,
  Checkbox,
  Spinner,
  Dialog,
  Popover, MoreIcon, Position, Radio, ErrorIcon
} from 'evergreen-ui';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./MilestoneData.css";
import { withRouter } from "react-router";
import { globalContext } from "../../global/Store";

const MilestoneData = (props: any) => {

  const { globalState, dispatch, globalFunctions } = useContext(globalContext);
  const [selectedCase, setSelectedCase] = useState(props.case);
  const [selectedMilestone, setSelectedMilestone] = useState(props.selectedMilestone);
  const [showFormLoading, setShowFormLoading] = useState(false);
  const [isQualifiedNoUpdateStatusConfirmedShown, setIsQualifiedNoUpdateStatusConfirmedShown] = useState(false);
  const [isQualifiedNoEmailShown, setIsQualifiedNoEmailShown] = useState(false);
  const [isAssignCaseStatusShown, setIsAssignCaseStatusShown] = useState(false);
  const [isSendEmailShown, setIsSendEmailShown] = useState(false);
  const [isDeleteModalShown, setIsDeleteModalShown] = useState(false);
  const [showLoadingNotes, setShowLoadingNotes] = useState(false);
  const [showNoteFormLoading, setShowNoteFormLoading] = useState(false);
  const [showNoteFields, setShowNoteFields] = useState(false);
  const [milestoneData, setMilestoneData] = useState(!!props.selectedMilestone.milestoneData ? JSON.parse(props.selectedMilestone.milestoneData) : {});
  const [qualificationStatusInvalid, setQualificationStatusInvalid] = useState(false);
  const [caseProceedableInvalid, setCaseProceedableInvalid] = useState(false);
  const [sharedOwnershipPurchaseInvalid, setSharedOwnershipPurchaseInvalid] = useState(false);
  const [isHTBInvalid, setIsHTBInvalid] = useState(false);
  const [standardPurchaseInvalid, setStandardPurchaseInvalid] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [expectedBuildCompleteInvalid, setExpectedBuildCompleteInvalid] = useState(false);
  const [dateReservedInvalid, setDateReservedInvalid] = useState(false);

  const milestoneDescription = globalState.milestoneTypes.find((e: any) => e.id === props.selectedMilestone.milestoneTypeId)?.description;

  const closeSideSheet = () => {
    props.resetSelectedMilsetone();
  }

  const renderRowMenu = (_note: any) => {
    return (
      <Menu>
        <Menu.Group>
          {/* <Menu.Item icon={EyeOpenIcon} onClick={() => this.setState({ showNoteFields: true, note: _note, noteState: 'Update' })}>View...</Menu.Item> */}
        </Menu.Group>
        <Menu.Divider />
        <Menu.Group>
          {/* <Menu.Item icon={TrashIcon} onClick={() => this.handleDeleteNote(_note)} intent="danger">Delete...</Menu.Item> */}
        </Menu.Group>
      </Menu>
    )
  }

  if (!!selectedMilestone) {
    return (
      <Pane>
        <SideSheet
          isShown={true}
          onCloseComplete={() => closeSideSheet()}
          containerProps={{
            display: 'flex',
            flex: '1',
            flexDirection: 'column'
          }}
        >
          <Pane zIndex={1} tabIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
            <Pane padding={16} paddingTop={32}>
              <Pane display="flex" marginBottom={10}>
                <Icon icon={ChatIcon} size={25} marginRight={10} color='#234361' />
                <Heading size={600}>Milestone - {milestoneDescription}</Heading>
              </Pane>
            </Pane>
          </Pane>

          <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
            {milestoneDescription === "Qualification" ?
              <Pane>
                <SelectField
                  label="Qualification Status"
                  required
                  onChange={(e) => {
                    var _milestoneData = milestoneData;
                    _milestoneData.qualificationStatus = Number(e.target.value);
                    setMilestoneData(_milestoneData);
                  }}
                  value={milestoneData.qualificationStatus !== undefined ? milestoneData.qualificationStatus : ""}
                  width="100%"
                  marginBottom={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>Red</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Amber</option>
                  <option style={{ fontSize: '12px' }} key={2} value={2}>Green</option>
                </SelectField>

                <Pane>
                  <TextInputField
                    label="Date Qualified"
                    value={!!milestoneData.qualifiedDate ? moment(milestoneData.qualifiedDate).format('Do MMM YYYY') : ''}
                    disabled
                  />
                </Pane>
                <SelectField

                  label="Case Proceedable?"
                  value={milestoneData.caseProceedable !== undefined ? milestoneData.caseProceedable : ""}
                  width="100%"
                  marginTop={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>No</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Yes</option>
                </SelectField>
                {milestoneData.caseProceedable === 1 ?
                  <SelectField
                    label=""
                    value={milestoneData.caseProceedableYesWhy !== undefined ? milestoneData.caseProceedableYesWhy : ""}
                    width="100%"
                    marginBottom={24}
                    disabled={true}
                  >
                    <option value=""></option>
                    <option style={{ fontSize: '12px' }} key={0} value={"Proceeding with JMNB"}>Proceeding with JMNB</option>
                    <option style={{ fontSize: '12px' }} key={1} value={"Other IFA"}>Other IFA</option>
                  </SelectField> : null}
                {milestoneData.caseProceedable === 0 ?
                  <SelectField
                    label=""
                    value={milestoneData.caseProceedableNoWhy !== undefined ? milestoneData.caseProceedableNoWhy : ""}
                    width="100%"
                    marginBottom={24}
                    disabled={true}
                  >
                    <option value=""></option>
                    <option style={{ fontSize: '12px' }} key={0} value={"Cash Buyer"}>Cash Buyer</option>
                    <option style={{ fontSize: '12px' }} key={0} value={"Not Proceeding"}>Not Proceeding</option>
                    <option style={{ fontSize: '12px' }} key={0} value={"Proceeding via own means"}>Proceeding via own means</option>
                  </SelectField> : null}
                <SelectField
                  label="Shared Ownership Purchase?"
                  value={milestoneData.sharedOwnershipPurchase !== undefined ? milestoneData.sharedOwnershipPurchase : ""}
                  width="100%"
                  marginTop={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>No</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Yes</option>
                </SelectField>
                {milestoneData.sharedOwnershipPurchase === 1 ?
                  <div className="currency-wrap">
                    <span className="currency-code">%</span>
                    <TextInputField
                      label="Maximum Share Client Can Proceed With?"
                      className="text-currency"
                      value={milestoneData.maximumShare}
                      disabled={true}
                    /> </div> : null}
                {/* <SelectField
                  label="Is Help to Buy?"
                  value={milestoneData.isHTB !== undefined ? milestoneData.isHTB : ""}
                  width="100%"
                  marginTop={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>No</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Yes</option>
                </SelectField> */}
                <SelectField
                  label="Standard Purchase?"
                  value={milestoneData.standardPurchase !== undefined ? milestoneData.standardPurchase : ""}
                  width="100%"
                  marginTop={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>No</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Yes</option>
                </SelectField>
                <SelectField
                  label="Qualified to reserve plot seen?"
                  value={milestoneData.qualifiedReserve !== undefined ? milestoneData.qualifiedReserve : ""}
                  width="100%"
                  marginTop={24}
                  disabled={true}
                >
                  <option value=""></option>
                  <option style={{ fontSize: '12px' }} key={0} value={0}>No</option>
                  <option style={{ fontSize: '12px' }} key={1} value={1}>Yes</option>
                </SelectField>
                <Row style={{ marginTop: '25px' }}>

                  <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                    <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }} >
                      Qualified?
                    </Heading>

                    {milestoneData.isMilestoneComplete === 1 ?
                      <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                      null}

                    {milestoneData.isQualifiedNo === 1 ?
                      <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span> :
                      null}

                    {/* <Checkbox
                      marginLeft={20}
                      marginTop={2}
                      label="Yes"
                      checked={milestoneData.isMilestoneComplete === 1}
                      disabled={true}
                    />

                    <Checkbox
                      marginLeft={20}
                      marginTop={2}
                      label="No"
                      checked={milestoneData.isQualifiedNo === 1}
                      disabled={true}
                    /> */}
                  </Col>

                  {/* <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                    <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }} >
                      Qualified?
                    </Heading>

                    <Checkbox
                      marginLeft={20}
                      marginTop={2}
                      label="Yes"
                      checked={milestoneData.isFirstAppointmentYes === 1}
                      disabled={true}
                    />

                  </Col> */}
                </Row>

                {/* <Row style={{ marginBottom: '10px' }}>
                  <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                    <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }} >
                      FS 1st Appointment?
                    </Heading>

                    <Checkbox
                      marginLeft={20}
                      marginTop={2}
                      label="Yes"
                      checked={milestoneData.isFirstAppointmentYes}
                      disabled={true}
                    />

                    <Checkbox
                      marginLeft={20}
                      marginTop={2}
                      label="No"
                      checked={milestoneData.isFirstAppointmentNo}
                      disabled={true}
                    />
                  </Col>
                </Row> */}
              </Pane> : null}

            {/* DECISION IN PRINCIPAL */}
            {milestoneDescription === "Decision in Principle"
              || milestoneDescription === "PIF"
              || milestoneDescription === "ATP"
              || milestoneDescription === "Mortgage Agreed"
              || milestoneDescription === "Offer Expiry"
              || milestoneDescription === "Valuation Booked"
              || milestoneDescription === "Mortgage Offered"
              || milestoneDescription === "Exchanged"
              || milestoneDescription === "Completion" ?
              <Pane marginBottom={24}>
                <Pane>

                  {
                    milestoneDescription === "Decision in Principle" ?
                      <Row style={{ marginTop: '25px' }}>
                        <Pane>
                          <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                            <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>DIP Obtained?</Heading>
                            {milestoneData.isDIPobtain === 1 ?
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span>}






                            {/* <Checkbox
                              marginLeft={15}
                              marginTop={2}
                              label="Yes"
                              checked={milestoneData.isDIPobtain === 1}
                              disabled={true}
                            /> */}
                          </Col>
                        </Pane>
                      </Row> : null
                  }

                  <TextInputField
                    label={milestoneDescription === "Offer Expiry" ? "Offer Expiry Date"
                      : milestoneDescription === "Valuation Booked" ? "Date of Valuation"
                        : milestoneDescription === "Exchanged" ? "Exchanged Date"
                          : milestoneDescription === "Completion" ? "Completion date"
                            : "Date Completed"}

                    value={milestoneDescription === "Offer Expiry" ? !!milestoneData.offerExpiryDate ? moment(milestoneData.offerExpiryDate).format('Do MMM YYYY') : ''
                      : milestoneDescription === "Exchanged" ? !!milestoneData.exchangedDate ? moment(milestoneData.exchangedDate).format('Do MMM YYYY') : ''
                        : milestoneDescription === "Completion" ? !!milestoneData.completionDate ? moment(milestoneData.completionDate).format('Do MMM YYYY') : ''
                          : milestoneDescription === "Valuation Booked" ? !!milestoneData.valuationBookedDate ? moment(milestoneData.valuationBookedDate).format('Do MMM YYYY') : ''
                            : !!milestoneData.dateCompleted ? moment(milestoneData.dateCompleted).format('Do MMM YYYY') : ''}
                    disabled
                  />





                  <Row style={{ marginTop: '25px' }}>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                      <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Complete Milestone?</Heading>
                      
                      
                      {milestoneData.isMilestoneComplete === 1 ?
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span>}


                      
                      
                      
                      {/* <Checkbox
                        marginLeft={15}
                        marginTop={2}
                        label="Yes"
                        checked={milestoneData.isMilestoneComplete === 1}
                        disabled={true}
                      /> */}
                    </Col> 

                  </Row>

                </Pane>
              </Pane> : null}
            {/* DECISION IN PRINCIPAL */}


            {/* Reservation */}
            {milestoneDescription === "Reservation" ?
              <Pane marginBottom={24}>
                <Pane>

                  <TextInputField
                    label="Expected Build Completion"
                    value={!!milestoneData.expectedBuildComplete ? moment(milestoneData.expectedBuildComplete).format('Do MMM YYYY') : ""}
                    disabled
                  />

                  <TextInputField
                    label="Date Reserved"
                    value={!!milestoneData.dateReserved ? moment(milestoneData.dateReserved).format('Do MMM YYYY') : ""}
                    disabled
                  />


                  <Row style={{ marginTop: '25px' }}>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                      <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Complete Milestone?</Heading>
                      
                      {milestoneData.isMilestoneComplete === 1 ?
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span>}


                      
                      
                      {/* <Checkbox
                        marginLeft={15}
                        marginTop={2}
                        label="Yes"
                        checked={milestoneData.isMilestoneComplete === 1}
                        disabled={true}
                      /> */}
                    </Col>
                  </Row>
                </Pane>
              </Pane> : null}

            {/* Reservation */}

            {/* Mortgage Application */}

            {milestoneDescription === "Mortgage Application" ?
              <Pane marginBottom={24}>
                <Pane>
                  <TextInputField
                    label="Date Completed"
                    value={!!milestoneData.dateCompleted ? moment(milestoneData.dateCompleted).format('Do MMM YYYY') : ""}
                    disabled
                  />
                  <TextareaField
                    label="Lender Notes"
                    id="textarea"
                    placeholder=""
                    height={150}
                    value={milestoneData.lenderNotes}
                    style={{ marginTop: '24px' }}
                    disabled={true}
                  />
                  <Row style={{ marginTop: '25px' }}>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                      <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Complete Milestone?</Heading>
                      
                      {milestoneData.isMilestoneComplete === 1 ?
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span>}


                      
                      {/* <Checkbox
                        marginLeft={15}
                        marginTop={2}
                        label="Yes"
                        checked={milestoneData.isMilestoneComplete === 1}
                        disabled={true}

                      /> */}
                    </Col>

                  </Row>
                </Pane>
              </Pane> : null}

            {/* Mortgage Application */}

            {/* Valuation Instructed */}

            {milestoneDescription === "Valuation Instructed" ?
              <Pane marginBottom={24}>
                <Pane>
                  <TextInputField
                    label="Date Instructed"
                    value={!!milestoneData.dateInstructed ? moment(milestoneData.dateInstructed).format('Do MMM YYYY') : ""}
                    disabled
                  />
                  <TextareaField
                    label="Surveyor Details"
                    id="textarea"
                    height={150}
                    value={milestoneData.surveyorDetails}
                    style={{ marginTop: '24px' }}
                    disabled={true}

                  />
                  <TextareaField
                    label="Surveyor Contact"
                    id="textarea"
                    height={150}
                    value={milestoneData.surveyorContact}
                    style={{ marginTop: '24px' }}
                    disabled={true}

                  />
                  <Row style={{ marginTop: '25px' }}>
                    <Col xs={12} sm={6} md={6} lg={6} style={{ display: 'inline-flex' }}>
                      <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500' }}>Complete Milestone?</Heading>
                      
                      {milestoneData.isMilestoneComplete === 1 ?
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>Yes</span> :
                              <span style={{ marginLeft: '10px', marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '##696f8c', fontWeight: '400' }}>No</span>}



                      {/* <Checkbox
                        marginLeft={15}
                        marginTop={2}
                        label="Yes"
                        checked={milestoneData.isMilestoneComplete === 1}
                        disabled={true}
                      /> */}
                    </Col>
                  </Row>
                </Pane>
              </Pane> : null}


            {/* Valuation Instructed */}

            <Pane>
              <Pane style={{ display: 'inline-flex', width: '100%' }}>
                <Heading size={300} marginTop="default" style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '14px', color: '#425A70', fontWeight: '500', width: '89%' }}>Notes</Heading>
              </Pane>

              {selectedMilestone.notes !== null && selectedMilestone.notes.length > 0 ?
                <Row style={{ marginTop: '20px', marginLeft: '0px', marginRight: '0px', width: '100%', boxShadow: 'box-shadow: 0 0 1px rgb(67 90 111 / 30%), 0 2px 4px -2px rgb(67 90 111 / 47%)', border: '1px solid lightgray', borderRadius: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                  <Table style={{ width: '100%' }}>
                    <Table.Body>
                      {selectedMilestone.notes.map((_note: any, index: any) => (
                        <Table.Row key={index} style={{ height: '100%' }}>
                          <Table.TextCell style={{ padding: '0px' }}>
                            <div style={{ marginTop: '10px', paddingLeft: '10px' }}>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added By: {_note.milestoneNoteUser !== null ? _note.milestoneNoteUser.name : ""}</p>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Added Date: {moment(_note.dateAdded).format("DD/MM/YYYY")}</p>
                              <p style={{ marginBottom: '4px', lineHeight: '20px', marginTop: '0px', fontSize: '12px', color: '#425A70', fontWeight: '400' }}>Note: {_note.note}</p>
                            </div>
                          </Table.TextCell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                    {showLoadingNotes ?
                      <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
                        <Spinner></Spinner>
                      </Pane> : null}
                  </Table>
                </Row> : null}
            </Pane>

          </Pane>

          {showFormLoading ?
            <Pane display="flex" alignItems="center" justifyContent="center" height="100%" background="rgba(0,0,0,0.05)" style={{ position: 'absolute', width: '100%', top: '0' }}>
              <Spinner></Spinner>
            </Pane> : null}
        </SideSheet>
      </Pane>

    );
  } else {
    return null;
  }
}



export default MilestoneData;